import bleExtensionMessageType from "../../consts/bleExtensionMessageType";
import BLE_UUID_TYPES from "../../consts/bleUuidTypes";
import { timeout } from "../../utils/utils";
import EventEmitter from "./EventEmitter";
import log from "../logger/logger";
import { sendMessageAsync } from "./extensionUtils";
import { IBleDeviceDescription, IBleServiceDiscoveredDevicesResponse, IBleServiceScanningResponse, IBleServiceConnectedDevicesResponse } from "./Models";
import BleDeviceClient from "./BleDeviceClient";
import centralStateTypes from "../../consts/centralStateTypes";

let instance: BleService | null = null;

const DISCOVERED_DEVICES_TIMEOUT = 300;

// class BleServiceMock {
//     constructor(options) {
//         if (instance) return instance;

//         this.options = options;
//         instance = this;
//     }

//     #devices = [];
//     #eventEmmiter = new EventEmitter();

//     init() {}

//     startScanning() {
//         const message = {
//             type: bleExtensionMessageType.startScanning,
//             services: [BLE_UUID_TYPES.RRP_SERVICE, BLE_UUID_TYPES.DEVICE_INFO_SERVICE],
//         };

//         log.debug(`MOCK: Start scanning. ${JSON.stringify(message)}`);
//     }

//     stopScanning() {
//         const message = {
//             type: bleExtensionMessageType.stopScanning,
//             services: [BLE_UUID_TYPES.RRP_SERVICE, BLE_UUID_TYPES.DEVICE_INFO_SERVICE],
//         };

//         log.debug(`MOCK: Stop scanning. ${JSON.stringify(message)}`);
//     }

//     isScanning() {
//         const message = { type: bleExtensionMessageType.isScanning };
//         log.debug(`MOCK: Is scanning. ${JSON.stringify(message)}`);
//     }

//     discoveredDevices() {
//         const message = { type: bleExtensionMessageType.discoveredDevices };
//         log.debug(`MOCK: discoveredDevices. ${JSON.stringify(message)}`);
//         setTimeout(() => {
//             this.#onDeviceListUpdated([
//                 { id: 1, name: "Device1", connectionStatus: bleDeviceConnectionStatus.DISCONNECTED },
//                 { id: 2, name: "Device2", connectionStatus: bleDeviceConnectionStatus.DISCONNECTED },
//             ]);
//         }, 1000);
//     }

//     connect(deviceId) {
//         const message = { type: bleExtensionMessageType.connect, id: deviceId };
//         log.debug(`MOCK: connect. ${JSON.stringify(message)}`);
//         setTimeout(() => {
//             this.#onDevicePropsUpdated(deviceId, "connectionStatus", bleDeviceConnectionStatus.CONNECTING);
//         }, 100);

//         setTimeout(() => {
//             this.#onDevicePropsUpdated(deviceId, "connectionStatus", bleDeviceConnectionStatus.CONNECTED);
//         }, 1000);
//     }

//     disconnect(deviceId) {
//         const message = { type: bleExtensionMessageType.disconnect, id: deviceId };
//         log.debug(`MOCK: disconnect. ${JSON.stringify(message)}`);
//         setTimeout(() => {
//             this.#onDevicePropsUpdated(deviceId, "connectionStatus", bleDeviceConnectionStatus.DISCONNECTING);
//         }, 100);

//         setTimeout(() => {
//             this.#onDevicePropsUpdated(deviceId, "connectionStatus", bleDeviceConnectionStatus.DISCONNECTED);
//         }, 1000);
//     }

//     getConnectionStatus(deviceId) {
//         const message = { type: bleExtensionMessageType.connectionStatus, id: deviceId };
//         log.debug(`MOCK: getConnectionStatus.  ${JSON.stringify(message)}`);
//     }

//     getServices(deviceId) {
//         // const message = { type: bleExtensionMessageType.services, id: deviceId };
//         // this.#sendMessage(message);
//     }

//     getCharacteristicsForService(deviceId, service) {
//         // const message = { type: bleExtensionMessageType.characteristicsForService, id: deviceId, service };
//         // this.#sendMessage(message);
//     }

//     writeFrame(deviceId, frame, service, characteristic) {
//         const message = { type: bleExtensionMessageType.write, id: deviceId, value: frame, service, characteristic };
//         log.debug(`[${deviceId}]. writeFrame: [${frame}]. ${JSON.stringify(message)}`);
//         this.readResponse(deviceId, frame, service, characteristic);
//         // this.#sendMessage(message);
//     }

//     readResponse(deviceId, service, characteristic) {
//         const message = { type: bleExtensionMessageType.read, id: deviceId, value: frame, service, characteristic };
//         log.debug(`[${deviceId}]. readResponse: [${frame}]. ${JSON.stringify(message)}`);
//     }

//     subscribeOnDeviceUpdated(deviceId, callback) {
//         this.#eventEmmiter.subscribe(`bleDeviceUpdated-${deviceId}`, callback);
//     }

//     unsubscribeOnDeviceUpdated(deviceId, callback) {
//         this.#eventEmmiter.unsubscribe(`bleDeviceUpdated-${deviceId}`, callback);
//     }

//     #onDeviceListUpdated(devices) {
//         this.#devices = devices;
//         runFunction(this.options.onDeviceListUpdated, [this.#devices]);
//     }

//     #onDevicePropsUpdated(deviceId, propName, propValue) {
//         let updated = false;
//         let device = null;
//         let devices = this.#devices.map((item) => {
//             if (item.id === deviceId) {
//                 const isValJson = isObject(propValue) || Array.isArray(propValue);
//                 const val = isValJson ? JSON.stringify(propValue) : propValue;
//                 const isExPropJson = isObject(item[propName]) || Array.isArray(item[propName]);
//                 const valEx = isExPropJson ? JSON.stringify(item[propName]) : item[propName];
//                 if (valEx !== val) {
//                     item[propName] = propValue;
//                     updated = true;
//                     device = item;
//                 }
//             }

//             return item;
//         });

//         if (updated) {
//             this.#onDeviceListUpdated(devices);
//             this.#eventEmmiter.emit(`bleDeviceUpdated-${deviceId}`, { ...device });
//         }
//     }
// }

export default class BleService {
    private eventEmmiter = new EventEmitter();
    private devices: IBleDeviceDescription[] = [];
    private deviceServices: {[key: string]: BleDeviceClient} = {}
    private isScanRunning = false;

    constructor() {
        if (instance) return instance;
        instance = this;
    }

    getDeviceList(): IBleDeviceDescription[] {
        return this.devices;
    }

    async centralStateCheck(onCentralStateChange: (arg0: any) => void) {
        while (true) {
            const state = await sendMessageAsync<any>({type: bleExtensionMessageType.centralState})

            onCentralStateChange(state?.centralState || null);
            
            if (state?.centralState === centralStateTypes.POWERED_ON) {
                break;
            }
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
    }

    async getConnectedDevices(onDeviceListUpdatedHandler: (arg0: IBleDeviceDescription[]) => void) : Promise<void> {
        const message = { 
            type: bleExtensionMessageType.connectedDevices, 
            services: [BLE_UUID_TYPES.RRP_SERVICE]
        };
        
        const {connectedDevices} = await sendMessageAsync<IBleServiceConnectedDevicesResponse>(message);

        onDeviceListUpdatedHandler(connectedDevices);
    }

    async startScanning(onDeviceListUpdatedHandler: (arg0: IBleDeviceDescription[]) => void, onCentralStateChange: (arg0: any) => void) : Promise<void> {

        await this.centralStateCheck(onCentralStateChange);
        
        const message = {
            type: bleExtensionMessageType.startScan,
            services: [BLE_UUID_TYPES.RRP_SERVICE],
        };

        const {isScanning} = await sendMessageAsync<IBleServiceScanningResponse>(message);
        if(isScanning) {
            this.isScanRunning = true;
        }
        
        this.runDiscoveredDevices(onDeviceListUpdatedHandler);
    }

    private async runDiscoveredDevices(onDeviceListUpdatedHandler: (arg0: IBleDeviceDescription[]) => void): Promise<void> {
        while(this.isScanRunning) {
            await timeout(DISCOVERED_DEVICES_TIMEOUT);

            const {discoveredDevices} = await sendMessageAsync<IBleServiceDiscoveredDevicesResponse>({ type: bleExtensionMessageType.discoveredDevices });

            log.info(`Scaned devices: ${JSON.stringify(discoveredDevices)}`);

            discoveredDevices.forEach(device => {
                if(!this.deviceServices[device.id]) {
                    this.deviceServices[device.id] = new BleDeviceClient(device);
                }
            });

            this.devices = discoveredDevices;
            onDeviceListUpdatedHandler(discoveredDevices);            
        }
    }

    async stopScanning(): Promise<void> {
        const message = {
            type: bleExtensionMessageType.stopScan,
            services: [BLE_UUID_TYPES.RRP_SERVICE],
        };

        this.isScanRunning = false;
        const {isScanning} = await sendMessageAsync<IBleServiceScanningResponse>(message);
    }

    async isScanning(): Promise<boolean> {
        const message = { type: bleExtensionMessageType.isScanning };
        const {isScanning} = await sendMessageAsync<IBleServiceScanningResponse>(message);
        return isScanning;
    }

    getDevice(id: string):BleDeviceClient | null {
        return this.deviceServices[id];
    }


    // #onDevicePropsUpdated(deviceId, propName, propValue) {
    //     let updated = false;
    //     let device = null;
    //     let devices = this.#devices.map((item) => {
    //         if (item.id === deviceId) {
    //             const isValJson = isObject(propValue) || Array.isArray(propValue);
    //             const val = isValJson ? JSON.stringify(propValue) : propValue;
    //             const isExPropJson = isObject(item[propName]) || Array.isArray(item[propName]);
    //             const valEx = isExPropJson ? JSON.stringify(item[propName]) : item[propName];
    //             if (valEx !== val) {
    //                 item[propName] = propValue;
    //                 updated = true;
    //                 device = item;
    //             }
    //         }

    //         return item;
    //     });

    //     if (updated) {
    //         this.#onDeviceListUpdated(devices);
    //         this.eventEmmiter.emit(`${bleEventsType.deviceUpdated}-${deviceId}`, { ...device });
    //     }
    // }

    // #sendMessage(message : IBleDeviceMessageDataBase) {
    //     this.bleExtensionClient.sendMessage(message);
    // }
}

// const BleService = BleServiceImpl;

// export default BleService;
